module.exports = __webpack_public_path__ + "img/vertical_7_5_8004.828c6189.png";